"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheBurden() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: visualRef,
    isVisible: visualVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section id="the-burden" className="relative pt-24 pb-24 overflow-hidden !bg-[hsl(210,100%,12%)] min-h-[80vh] flex items-center">
      {}
      <div ref={visualRef} className={`absolute right-0 top-1/2 -translate-y-1/2 w-1/2 h-full flex items-center justify-end transition-all duration-700 ease-out delay-200 ${visualVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`} style={{
      maskImage: "linear-gradient(to right, transparent 0%, rgba(0,0,0,0.3) 30%, rgba(0,0,0,1) 60%)",
      WebkitMaskImage: "linear-gradient(to right, transparent 0%, rgba(0,0,0,0.3) 30%, rgba(0,0,0,1) 60%)"
    }}>
        <img src="https://familylegacyvoices.com/wp-content/uploads/2026/02/swiss_watch_chronometer.jpg" alt="Architectural compass and ruler symbolizing family legacy planning" className="w-full h-full object-contain opacity-35" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        {}
        <div ref={contentRef} className={`max-w-[650px] pl-20 transition-all duration-700 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-[var(--font-cinzel)] tracking-[4px] mb-6 leading-[1.2] !font-bold !text-[40px] !text-[hsl(46,65%,52%)]">The Burden of Family Wisdom Legacy Curation</h2>

          <p className="font-[var(--font-libre-baskerville)] font-normal text-[18px] leading-[1.6] mb-8 text-white text-left">
            Every family intends to record their history, yet few ever start or complete the journey. The reason is simple: a true family wisdom legacy is not merely a collection of stories—it is an exhaustive structural undertaking. It is a process that is notoriously time-consuming, requiring immense patience and a sophisticated suite of digital technology tools to bridge the gap between memory and a permanent record.
          </p>

          <p className="font-[var(--font-libre-baskerville)] font-normal text-[18px] leading-[1.6] mb-8 text-white text-left">
            Designing a family wisdom legacy requires more than just memory; it requires the ability to navigate complex emotional terrain while solving significant technical challenges. This is not merely documentation—it is the precision-engineering of your family's essence into a durable structure that remains accessible and relevant to generations yet unborn.
          </p>

          <p className="font-[var(--font-libre-baskerville)] font-normal text-[18px] leading-[1.6] text-white text-left">
            Without a professional lead, these stories often vanish under the weight of time. <span className="text-[#D4AF37]">As your Family Wisdom Legacy Architect, I step into that gap to manage the technical architecture and the narrative heavy lifting, transforming a daunting life-project into a refined, effortless experience.</span> You provide the wisdom; I provide the structure.
          </p>
        </div>
      </div>
    </section>;
}